import React from "react";
import "./style.scss";

function LayoutBox({ className, children }) {
  return <div style={{position:"relative"}} className={`layoutbox ${className}`}>{children}</div>;
}

export default LayoutBox;
